import React, { useMemo, useState, useRef } from "react";
import { ZoomIn, ZoomOut, RotateCcw } from "lucide-react";
import { useTheme } from '../context/ThemeProvider';

const MOROCCO_GEOJSON = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -11.994013,
                24.348005
              ],
              [
                -12.127951,
                24.360715
              ],
              [
                -12.246791,
                24.404011
              ],
              [
                -12.375138,
                24.360715
              ],
              [
                -12.517746,
                24.339061
              ],
              [
                -12.72215,
                24.40834
              ],
              [
                -12.90754,
                24.473254
              ],
              [
                -13.09293,
                24.490559
              ],
              [
                -13.287828,
                24.507861
              ],
              [
                -13.420929,
                24.512187
              ],
              [
                -13.639594,
                24.373705
              ],
              [
                -13.744173,
                24.421325
              ],
              [
                -13.986606,
                24.490559
              ],
              [
                -14.143475,
                24.568401
              ],
              [
                -14.200518,
                24.503536
              ],
              [
                -14.343126,
                24.481907
              ],
              [
                -14.457212,
                24.512187
              ],
              [
                -14.504748,
                24.503536
              ],
              [
                -14.604574,
                24.455947
              ],
              [
                -14.709153,
                24.633233
              ],
              [
                -14.925045,
                24.689447
              ],
              [
                -14.841857,
                25.066789
              ],
              [
                -14.812147,
                25.389302
              ],
              [
                -14.699249,
                25.528792
              ],
              [
                -14.687365,
                25.71631
              ],
              [
                -14.574467,
                25.839376
              ],
              [
                -14.497222,
                26.053098
              ],
              [
                -14.467512,
                26.229127
              ],
              [
                -14.348672,
                26.293071
              ],
              [
                -14.16447,
                26.447458
              ],
              [
                -14.07534,
                26.458098
              ],
              [
                -13.665342,
                26.649445
              ],
              [
                -13.540561,
                26.803353
              ],
              [
                -13.397953,
                27.17928
              ],
              [
                -13.237519,
                27.559213
              ],
              [
                -13.118679,
                27.727652
              ],
              [
                -13.023607,
                27.822285
              ],
              [
                -12.946361,
                27.958832
              ],
              [
                -12.851289,
                27.958832
              ],
              [
                -12.22738,
                28.03753
              ],
              [
                -11.904657,
                28.191148
              ],
              [
                -11.895025,
                28.10354
              ],
              [
                -11.766678,
                27.948282
              ],
              [
                -11.704881,
                27.771772
              ],
              [
                -11.471955,
                27.754946
              ],
              [
                -11.300825,
                27.6792
              ],
              [
                -11.177232,
                27.742326
              ],
              [
                -10.692365,
                27.729703
              ],
              [
                -10.635322,
                27.66657
              ],
              [
                -10.383382,
                27.712872
              ],
              [
                -10.274049,
                27.653939
              ],
              [
                -10.136195,
                27.510686
              ],
              [
                -9.955558,
                27.552839
              ],
              [
                -9.836718,
                27.434771
              ],
              [
                -9.698864,
                27.303905
              ],
              [
                -9.503967,
                27.308128
              ],
              [
                -9.356605,
                27.329246
              ],
              [
                -9.266287,
                27.265882
              ],
              [
                -8.976318,
                26.834057
              ],
              [
                -8.824203,
                26.787388
              ],
              [
                -8.668126,
                26.787388
              ],
              [
                -8.668126,
                25.999704
              ],
              [
                -12.001584,
                25.989022
              ],
              [
                -11.994013,
                24.348005
              ]
            ]
          ]
        ]
      },
      "properties": {
        "cartodb_id": 1,
        "region": "Laayoune-Saguia Hamra"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -5.807651,
                33.557246
              ],
              [
                -5.846076,
                33.515642
              ],
              [
                -5.855583,
                33.460139
              ],
              [
                -5.808047,
                33.368878
              ],
              [
                -5.974423,
                33.360938
              ],
              [
                -6.11703,
                33.372848
              ],
              [
                -6.193088,
                33.464105
              ],
              [
                -6.23587,
                33.527531
              ],
              [
                -6.326189,
                33.515642
              ],
              [
                -6.383232,
                33.420472
              ],
              [
                -6.378478,
                33.372848
              ],
              [
                -6.345203,
                33.293417
              ],
              [
                -6.454536,
                33.245723
              ],
              [
                -6.530593,
                33.221866
              ],
              [
                -6.649433,
                33.293417
              ],
              [
                -6.83007,
                33.269573
              ],
              [
                -6.811055,
                33.345055
              ],
              [
                -6.763519,
                33.483931
              ],
              [
                -6.806302,
                33.531494
              ],
              [
                -6.744505,
                33.567149
              ],
              [
                -6.754012,
                33.606749
              ],
              [
                -6.811055,
                33.614667
              ],
              [
                -6.920388,
                33.666114
              ],
              [
                -7.005953,
                33.6305
              ],
              [
                -7.005953,
                33.812374
              ],
              [
                -7.078837,
                33.85837
              ],
              [
                -7.047388,
                33.871745
              ],
              [
                -6.983215,
                33.906076
              ],
              [
                -6.919041,
                33.961686
              ],
              [
                -6.840607,
                34.030261
              ],
              [
                -6.806381,
                34.070434
              ],
              [
                -6.749338,
                34.129478
              ],
              [
                -6.692295,
                34.219146
              ],
              [
                -6.67946,
                34.268659
              ],
              [
                -6.663179,
                34.284764
              ],
              [
                -6.446296,
                34.583712
              ],
              [
                -6.342311,
                34.791363
              ],
              [
                -6.236105,
                35.031816
              ],
              [
                -5.988287,
                35.010417
              ],
              [
                -5.807651,
                34.963683
              ],
              [
                -5.731593,
                34.924717
              ],
              [
                -5.764868,
                34.827222
              ],
              [
                -5.707825,
                34.721797
              ],
              [
                -5.565217,
                34.729611
              ],
              [
                -5.43687,
                34.65535
              ],
              [
                -5.394088,
                34.573194
              ],
              [
                -5.299016,
                34.510544
              ],
              [
                -5.398842,
                34.459607
              ],
              [
                -5.503421,
                34.424324
              ],
              [
                -5.503421,
                34.361563
              ],
              [
                -5.465392,
                34.251618
              ],
              [
                -5.503421,
                34.165131
              ],
              [
                -5.641275,
                34.141528
              ],
              [
                -5.679304,
                34.15333
              ],
              [
                -5.669796,
                34.231969
              ],
              [
                -5.802897,
                34.283045
              ],
              [
                -5.850433,
                34.231969
              ],
              [
                -5.897969,
                34.184795
              ],
              [
                -5.855187,
                34.102176
              ],
              [
                -5.72684,
                34.007655
              ],
              [
                -5.788636,
                33.909084
              ],
              [
                -5.722086,
                33.849887
              ],
              [
                -5.774376,
                33.723462
              ],
              [
                -5.807651,
                33.557246
              ]
            ]
          ]
        ]
      },
      "properties": {
        "cartodb_id": 5,
        "region": "Rabat-Sale-Kenitra"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -5.256234,
                32.980949
              ],
              [
                -5.225732,
                32.569277
              ],
              [
                -5.255441,
                32.504155
              ],
              [
                -5.326745,
                32.514177
              ],
              [
                -5.338629,
                32.444001
              ],
              [
                -5.469353,
                32.388824
              ],
              [
                -5.463411,
                32.333613
              ],
              [
                -5.409933,
                32.293439
              ],
              [
                -5.433701,
                32.233144
              ],
              [
                -5.386165,
                32.177838
              ],
              [
                -5.493121,
                32.213037
              ],
              [
                -5.576309,
                32.213037
              ],
              [
                -5.629787,
                32.112434
              ],
              [
                -5.778337,
                32.067127
              ],
              [
                -5.808047,
                31.971404
              ],
              [
                -5.766453,
                31.910896
              ],
              [
                -5.819931,
                31.82006
              ],
              [
                -5.980365,
                31.693749
              ],
              [
                -6.140798,
                31.648236
              ],
              [
                -6.336884,
                31.557141
              ],
              [
                -6.556738,
                31.516626
              ],
              [
                -6.663694,
                31.491295
              ],
              [
                -6.705288,
                31.364538
              ],
              [
                -6.818186,
                31.298557
              ],
              [
                -6.990503,
                31.329015
              ],
              [
                -6.990503,
                31.384831
              ],
              [
                -7.097459,
                31.344241
              ],
              [
                -7.139053,
                31.420332
              ],
              [
                -7.067749,
                31.567267
              ],
              [
                -7.198473,
                31.60776
              ],
              [
                -7.281661,
                31.729134
              ],
              [
                -7.198473,
                31.799862
              ],
              [
                -7.085575,
                31.769556
              ],
              [
                -6.966736,
                31.804911
              ],
              [
                -6.990503,
                31.91594
              ],
              [
                -7.020213,
                32.036909
              ],
              [
                -7.067749,
                32.087266
              ],
              [
                -7.029721,
                32.334617
              ],
              [
                -6.986938,
                32.422937
              ],
              [
                -6.934649,
                32.599317
              ],
              [
                -7.020213,
                32.715378
              ],
              [
                -6.958417,
                32.959015
              ],
              [
                -6.834823,
                33.010851
              ],
              [
                -6.83007,
                33.269573
              ],
              [
                -6.649433,
                33.293417
              ],
              [
                -6.530593,
                33.221866
              ],
              [
                -6.454536,
                33.245723
              ],
              [
                -6.345203,
                33.293417
              ],
              [
                -6.378478,
                33.372848
              ],
              [
                -6.383232,
                33.420472
              ],
              [
                -6.326189,
                33.515642
              ],
              [
                -6.23587,
                33.527531
              ],
              [
                -6.193088,
                33.464105
              ],
              [
                -6.11703,
                33.372848
              ],
              [
                -5.974423,
                33.360938
              ],
              [
                -5.808047,
                33.368878
              ],
              [
                -5.855583,
                33.460139
              ],
              [
                -5.846076,
                33.515642
              ],
              [
                -5.807651,
                33.557246
              ],
              [
                -5.779129,
                33.477983
              ],
              [
                -5.617507,
                33.45419
              ],
              [
                -5.527189,
                33.283483
              ],
              [
                -5.408349,
                33.192036
              ],
              [
                -5.284755,
                33.211924
              ],
              [
                -5.313277,
                33.096512
              ],
              [
                -5.256234,
                32.980949
              ]
            ]
          ]
        ]
      },
      "properties": {
        "cartodb_id": 7,
        "region": "Beni Mellal-Khenifra"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -11.994013,
                24.348005
              ],
              [
                -11.9897,
                23.403447
              ],
              [
                -12.156076,
                23.425258
              ],
              [
                -12.268974,
                23.370724
              ],
              [
                -12.334336,
                23.272507
              ],
              [
                -12.429408,
                23.272507
              ],
              [
                -12.482886,
                23.234292
              ],
              [
                -12.5839,
                23.283424
              ],
              [
                -12.774044,
                23.157829
              ],
              [
                -12.970129,
                23.043052
              ],
              [
                -13.172157,
                22.763902
              ],
              [
                -13.077085,
                22.517118
              ],
              [
                -12.982013,
                21.343082
              ],
              [
                -16.927497,
                21.348617
              ],
              [
                -17.040395,
                21.005092
              ],
              [
                -17.046337,
                20.783042
              ],
              [
                -17.099815,
                20.899659
              ],
              [
                -17.081989,
                20.971806
              ],
              [
                -17.052279,
                21.210195
              ],
              [
                -17.004743,
                21.514551
              ],
              [
                -17.004743,
                21.729982
              ],
              [
                -16.957207,
                21.763096
              ],
              [
                -16.986917,
                21.818271
              ],
              [
                -16.909671,
                21.884451
              ],
              [
                -16.850251,
                22.093821
              ],
              [
                -16.838367,
                22.176382
              ],
              [
                -16.778947,
                22.165377
              ],
              [
                -16.778947,
                22.203892
              ],
              [
                -16.725469,
                22.264394
              ],
              [
                -16.654165,
                22.297384
              ],
              [
                -16.606629,
                22.28089
              ],
              [
                -16.535325,
                22.32487
              ],
              [
                -16.499673,
                22.385319
              ],
              [
                -16.481847,
                22.47869
              ],
              [
                -16.493731,
                22.517118
              ],
              [
                -16.374891,
                22.599429
              ],
              [
                -16.315471,
                22.813205
              ],
              [
                -16.279819,
                22.917232
              ],
              [
                -16.172864,
                22.971951
              ],
              [
                -16.155038,
                23.053987
              ],
              [
                -16.244168,
                23.103185
              ],
              [
                -16.04214,
                23.316168
              ],
              [
                -15.994604,
                23.474319
              ],
              [
                -15.881706,
                23.621393
              ],
              [
                -15.74504,
                23.806362
              ],
              [
                -15.74504,
                23.887883
              ],
              [
                -15.816344,
                23.855281
              ],
              [
                -15.994604,
                23.670381
              ],
              [
                -15.762866,
                23.974782
              ],
              [
                -15.602432,
                24.056196
              ],
              [
                -15.465766,
                24.224289
              ],
              [
                -15.222145,
                24.397572
              ],
              [
                -15.049827,
                24.597634
              ],
              [
                -14.925045,
                24.689447
              ],
              [
                -14.709153,
                24.633233
              ],
              [
                -14.604574,
                24.455947
              ],
              [
                -14.504748,
                24.503536
              ],
              [
                -14.457212,
                24.512187
              ],
              [
                -14.343126,
                24.481907
              ],
              [
                -14.200518,
                24.503536
              ],
              [
                -14.143475,
                24.568401
              ],
              [
                -13.986606,
                24.490559
              ],
              [
                -13.744173,
                24.421325
              ],
              [
                -13.639594,
                24.373705
              ],
              [
                -13.420929,
                24.512187
              ],
              [
                -13.287828,
                24.507861
              ],
              [
                -13.09293,
                24.490559
              ],
              [
                -12.90754,
                24.473254
              ],
              [
                -12.72215,
                24.40834
              ],
              [
                -12.517746,
                24.339061
              ],
              [
                -12.375138,
                24.360715
              ],
              [
                -12.246791,
                24.404011
              ],
              [
                -12.127951,
                24.360715
              ],
              [
                -11.994013,
                24.348005
              ]
            ]
          ]
        ]
      },
      "properties": {
        "cartodb_id": 11,
        "region": "Dakhla-Oued Eddahab"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -3.862242,
                34.914729
              ],
              [
                -4.039314,
                34.870134
              ],
              [
                -4.210443,
                34.772574
              ],
              [
                -4.281747,
                34.819417
              ],
              [
                -4.471891,
                34.710075
              ],
              [
                -4.719078,
                34.745237
              ],
              [
                -4.804642,
                34.874034
              ],
              [
                -4.985279,
                34.815515
              ],
              [
                -5.13264,
                34.819417
              ],
              [
                -5.213451,
                34.577108
              ],
              [
                -5.299016,
                34.510544
              ],
              [
                -5.394088,
                34.573194
              ],
              [
                -5.43687,
                34.65535
              ],
              [
                -5.565217,
                34.729611
              ],
              [
                -5.707825,
                34.721797
              ],
              [
                -5.764868,
                34.827222
              ],
              [
                -5.731593,
                34.924717
              ],
              [
                -5.807651,
                34.963683
              ],
              [
                -5.988287,
                35.010417
              ],
              [
                -6.236105,
                35.031816
              ],
              [
                -6.205645,
                35.100646
              ],
              [
                -6.110574,
                35.323964
              ],
              [
                -6.012531,
                35.498305
              ],
              [
                -6.006589,
                35.561169
              ],
              [
                -5.929343,
                35.792854
              ],
              [
                -5.893691,
                35.800083
              ],
              [
                -5.798619,
                35.795264
              ],
              [
                -5.751083,
                35.819358
              ],
              [
                -5.697605,
                35.838629
              ],
              [
                -5.62333,
                35.831403
              ],
              [
                -5.584707,
                35.841037
              ],
              [
                -5.531229,
                35.87234
              ],
              [
                -5.480722,
                35.922881
              ],
              [
                -5.406447,
                35.930099
              ],
              [
                -5.287607,
                35.915663
              ],
              [
                -5.317317,
                35.903631
              ],
              [
                -5.341085,
                35.843445
              ],
              [
                -5.335143,
                35.768751
              ],
              [
                -5.26681,
                35.698813
              ],
              [
                -5.257897,
                35.616738
              ],
              [
                -5.210362,
                35.566002
              ],
              [
                -5.147971,
                35.546666
              ],
              [
                -5.061812,
                35.447494
              ],
              [
                -4.904349,
                35.345777
              ],
              [
                -4.740944,
                35.243931
              ],
              [
                -4.616162,
                35.19296
              ],
              [
                -4.512177,
                35.188104
              ],
              [
                -4.434931,
                35.173535
              ],
              [
                -4.357686,
                35.168677
              ],
              [
                -4.253701,
                35.197816
              ],
              [
                -4.045731,
                35.236652
              ],
              [
                -3.938775,
                35.260914
              ],
              [
                -3.882326,
                35.214809
              ],
              [
                -3.840732,
                35.207527
              ],
              [
                -3.862242,
                34.914729
              ]
            ]
          ]
        ]
      },
      "properties": {
        "cartodb_id": 3,
        "region": "Tanger-Tetouan-Hoceima"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -7.139053,
                31.420332
              ],
              [
                -7.196096,
                31.378946
              ],
              [
                -7.196096,
                31.31196
              ],
              [
                -7.395747,
                31.278449
              ],
              [
                -7.463486,
                31.226635
              ],
              [
                -7.584703,
                31.211391
              ],
              [
                -7.708677,
                31.14497
              ],
              [
                -7.792673,
                31.105423
              ],
              [
                -7.882991,
                31.050461
              ],
              [
                -7.913889,
                30.968977
              ],
              [
                -7.940034,
                30.907818
              ],
              [
                -8.011338,
                30.897621
              ],
              [
                -8.123047,
                30.948595
              ],
              [
                -8.187221,
                30.924131
              ],
              [
                -8.306061,
                30.856822
              ],
              [
                -8.382118,
                30.881304
              ],
              [
                -8.484321,
                30.887423
              ],
              [
                -8.641189,
                30.891502
              ],
              [
                -8.71487,
                30.842539
              ],
              [
                -8.745768,
                30.852741
              ],
              [
                -8.743391,
                30.946556
              ],
              [
                -8.795681,
                30.993429
              ],
              [
                -8.850347,
                30.979166
              ],
              [
                -8.916898,
                30.932286
              ],
              [
                -8.969187,
                30.832335
              ],
              [
                -9.040491,
                30.834376
              ],
              [
                -9.154577,
                30.84866
              ],
              [
                -9.249649,
                30.824171
              ],
              [
                -9.306692,
                30.911896
              ],
              [
                -9.361359,
                30.92617
              ],
              [
                -9.430286,
                30.832335
              ],
              [
                -9.503967,
                30.856822
              ],
              [
                -9.537242,
                30.92617
              ],
              [
                -9.675096,
                30.82213
              ],
              [
                -9.772545,
                30.828253
              ],
              [
                -9.758284,
                30.918014
              ],
              [
                -9.826782,
                30.96461
              ],
              [
                -9.829786,
                30.979421
              ],
              [
                -9.817902,
                31.050715
              ],
              [
                -9.829786,
                31.096519
              ],
              [
                -9.850583,
                31.13213
              ],
              [
                -9.832757,
                31.172811
              ],
              [
                -9.820873,
                31.195686
              ],
              [
                -9.81196,
                31.23888
              ],
              [
                -9.794134,
                31.327746
              ],
              [
                -9.817902,
                31.386099
              ],
              [
                -9.847612,
                31.403851
              ],
              [
                -9.832757,
                31.4216
              ],
              [
                -9.776308,
                31.47736
              ],
              [
                -9.776308,
                31.500162
              ],
              [
                -9.678265,
                31.626735
              ],
              [
                -9.678265,
                31.702597
              ],
              [
                -9.66341,
                31.712707
              ],
              [
                -9.363339,
                32.018018
              ],
              [
                -9.339571,
                32.060832
              ],
              [
                -9.324716,
                32.111176
              ],
              [
                -9.27421,
                32.166522
              ],
              [
                -9.253413,
                32.201724
              ],
              [
                -9.268268,
                32.249478
              ],
              [
                -9.250442,
                32.28716
              ],
              [
                -9.256384,
                32.317294
              ],
              [
                -9.280152,
                32.339889
              ],
              [
                -9.297977,
                32.372515
              ],
              [
                -9.27421,
                32.390078
              ],
              [
                -9.238558,
                32.432717
              ],
              [
                -9.232616,
                32.47283
              ],
              [
                -9.262326,
                32.505408
              ],
              [
                -9.268268,
                32.52044
              ],
              [
                -9.286094,
                32.547992
              ],
              [
                -9.208848,
                32.600569
              ],
              [
                -9.101892,
                32.680626
              ],
              [
                -9.039501,
                32.74562
              ],
              [
                -8.988664,
                32.780696
              ],
              [
                -8.950173,
                32.719378
              ],
              [
                -8.997709,
                32.687377
              ],
              [
                -8.983448,
                32.631349
              ],
              [
                -8.84084,
                32.555255
              ],
              [
                -8.745768,
                32.539227
              ],
              [
                -8.579392,
                32.547241
              ],
              [
                -8.569885,
                32.447009
              ],
              [
                -8.503335,
                32.338634
              ],
              [
                -8.346466,
                32.346666
              ],
              [
                -8.260902,
                32.471075
              ],
              [
                -8.070758,
                32.539227
              ],
              [
                -8.027975,
                32.623342
              ],
              [
                -8.080265,
                32.659368
              ],
              [
                -8.042236,
                32.691378
              ],
              [
                -8.032729,
                32.80732
              ],
              [
                -7.966179,
                32.879208
              ],
              [
                -7.909136,
                32.80732
              ],
              [
                -7.771281,
                32.66337
              ],
              [
                -7.642934,
                32.611331
              ],
              [
                -7.619166,
                32.523196
              ],
              [
                -7.552616,
                32.455032
              ],
              [
                -7.486066,
                32.455032
              ],
              [
                -7.357719,
                32.487115
              ],
              [
                -7.2674,
                32.378788
              ],
              [
                -7.158068,
                32.346666
              ],
              [
                -7.029721,
                32.334617
              ],
              [
                -7.067749,
                32.087266
              ],
              [
                -7.020213,
                32.036909
              ],
              [
                -6.990503,
                31.91594
              ],
              [
                -6.966736,
                31.804911
              ],
              [
                -7.085575,
                31.769556
              ],
              [
                -7.198473,
                31.799862
              ],
              [
                -7.281661,
                31.729134
              ],
              [
                -7.198473,
                31.60776
              ],
              [
                -7.067749,
                31.567267
              ],
              [
                -7.139053,
                31.420332
              ]
            ]
          ]
        ]
      },
      "properties": {
        "cartodb_id": 12,
        "region": "Marrakech-Safi"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -7.708677,
                31.14497
              ],
              [
                -7.584703,
                31.211391
              ],
              [
                -7.463486,
                31.226635
              ],
              [
                -7.395747,
                31.278449
              ],
              [
                -7.196096,
                31.31196
              ],
              [
                -7.196096,
                31.378946
              ],
              [
                -7.139053,
                31.420332
              ],
              [
                -7.097459,
                31.344241
              ],
              [
                -6.990503,
                31.384831
              ],
              [
                -6.990503,
                31.329015
              ],
              [
                -6.818186,
                31.298557
              ],
              [
                -6.705288,
                31.364538
              ],
              [
                -6.663694,
                31.491295
              ],
              [
                -6.556738,
                31.516626
              ],
              [
                -6.336884,
                31.557141
              ],
              [
                -6.140798,
                31.648236
              ],
              [
                -5.980365,
                31.693749
              ],
              [
                -5.819931,
                31.82006
              ],
              [
                -5.766453,
                31.910896
              ],
              [
                -5.808047,
                31.971404
              ],
              [
                -5.778337,
                32.067127
              ],
              [
                -5.629787,
                32.112434
              ],
              [
                -5.576309,
                32.213037
              ],
              [
                -5.493121,
                32.213037
              ],
              [
                -5.386165,
                32.177838
              ],
              [
                -5.433701,
                32.233144
              ],
              [
                -5.409933,
                32.293439
              ],
              [
                -5.463411,
                32.333613
              ],
              [
                -5.469353,
                32.388824
              ],
              [
                -5.338629,
                32.444001
              ],
              [
                -5.326745,
                32.514177
              ],
              [
                -5.255441,
                32.504155
              ],
              [
                -5.225732,
                32.569277
              ],
              [
                -5.256234,
                32.980949
              ],
              [
                -5.085104,
                33.004871
              ],
              [
                -5.032815,
                33.116422
              ],
              [
                -4.913975,
                33.156227
              ],
              [
                -4.818903,
                33.156227
              ],
              [
                -4.76186,
                33.084565
              ],
              [
                -4.757106,
                32.949043
              ],
              [
                -4.614498,
                32.925105
              ],
              [
                -4.52418,
                32.953032
              ],
              [
                -4.348297,
                32.829292
              ],
              [
                -4.2865,
                32.701379
              ],
              [
                -4.186675,
                32.633351
              ],
              [
                -4.110617,
                32.629348
              ],
              [
                -4.03456,
                32.717378
              ],
              [
                -3.927604,
                32.612332
              ],
              [
                -3.906807,
                32.524699
              ],
              [
                -3.79688,
                32.409394
              ],
              [
                -3.776083,
                32.311519
              ],
              [
                -3.701808,
                32.258774
              ],
              [
                -3.651301,
                32.198456
              ],
              [
                -3.577026,
                32.193428
              ],
              [
                -3.499781,
                32.246211
              ],
              [
                -3.419564,
                32.20097
              ],
              [
                -3.327463,
                32.213539
              ],
              [
                -3.161087,
                32.241186
              ],
              [
                -3.220507,
                32.173312
              ],
              [
                -3.241304,
                32.029857
              ],
              [
                -3.14029,
                31.926531
              ],
              [
                -3.095725,
                31.853377
              ],
              [
                -3.187826,
                31.833186
              ],
              [
                -3.226449,
                31.805416
              ],
              [
                -3.109163,
                31.738455
              ],
              [
                -3.355984,
                31.664674
              ],
              [
                -3.480766,
                31.619146
              ],
              [
                -3.605548,
                31.659616
              ],
              [
                -3.73033,
                31.664674
              ],
              [
                -3.771924,
                31.629265
              ],
              [
                -3.76004,
                31.588781
              ],
              [
                -3.801634,
                31.457088
              ],
              [
                -3.783808,
                31.411458
              ],
              [
                -3.688736,
                31.33536
              ],
              [
                -3.724388,
                31.325209
              ],
              [
                -3.748156,
                31.162642
              ],
              [
                -3.742214,
                31.11687
              ],
              [
                -3.617432,
                31.101607
              ],
              [
                -3.58178,
                31.065986
              ],
              [
                -3.52236,
                31.045625
              ],
              [
                -3.510476,
                30.964136
              ],
              [
                -3.546128,
                30.887678
              ],
              [
                -3.902648,
                30.851976
              ],
              [
                -4.140327,
                30.663047
              ],
              [
                -4.247283,
                30.627262
              ],
              [
                -4.378007,
                30.571002
              ],
              [
                -4.520615,
                30.530065
              ],
              [
                -4.883077,
                30.402026
              ],
              [
                -4.948438,
                30.258422
              ],
              [
                -5.150466,
                30.037478
              ],
              [
                -5.269306,
                29.934545
              ],
              [
                -5.382204,
                29.857276
              ],
              [
                -5.536696,
                29.877887
              ],
              [
                -5.584232,
                29.852122
              ],
              [
                -5.720898,
                29.831506
              ],
              [
                -5.833795,
                29.826351
              ],
              [
                -5.988287,
                29.73868
              ],
              [
                -6.101185,
                29.707718
              ],
              [
                -6.220025,
                29.71804
              ],
              [
                -6.297271,
                29.743839
              ],
              [
                -6.416111,
                29.7232
              ],
              [
                -6.464588,
                29.681093
              ],
              [
                -6.506825,
                29.713653
              ],
              [
                -6.435521,
                29.769373
              ],
              [
                -6.442652,
                29.827125
              ],
              [
                -6.392739,
                29.893085
              ],
              [
                -6.335696,
                29.989885
              ],
              [
                -6.392739,
                30.033106
              ],
              [
                -6.437898,
                29.987827
              ],
              [
                -6.499695,
                30.002236
              ],
              [
                -6.485434,
                30.107155
              ],
              [
                -6.544854,
                30.19142
              ],
              [
                -6.452159,
                30.312554
              ],
              [
                -6.513956,
                30.367939
              ],
              [
                -6.606651,
                30.36999
              ],
              [
                -6.630419,
                30.47042
              ],
              [
                -6.751635,
                30.42944
              ],
              [
                -6.832446,
                30.394594
              ],
              [
                -6.858591,
                30.306399
              ],
              [
                -6.944156,
                30.31871
              ],
              [
                -7.001199,
                30.275614
              ],
              [
                -7.043981,
                30.310503
              ],
              [
                -7.155691,
                30.378192
              ],
              [
                -7.291168,
                30.172929
              ],
              [
                -7.281661,
                30.096873
              ],
              [
                -7.31256,
                30.111267
              ],
              [
                -7.393371,
                30.146214
              ],
              [
                -7.450414,
                30.146214
              ],
              [
                -7.500326,
                30.187312
              ],
              [
                -7.581138,
                30.187312
              ],
              [
                -7.595398,
                30.228392
              ],
              [
                -7.574007,
                30.310503
              ],
              [
                -7.671456,
                30.337174
              ],
              [
                -7.678586,
                30.437638
              ],
              [
                -7.588268,
                30.468371
              ],
              [
                -7.507457,
                30.529809
              ],
              [
                -7.550239,
                30.613712
              ],
              [
                -7.612036,
                30.717977
              ],
              [
                -7.676209,
                30.724107
              ],
              [
                -7.673833,
                30.775173
              ],
              [
                -7.659572,
                30.844579
              ],
              [
                -7.709485,
                30.862943
              ],
              [
                -7.716615,
                30.977128
              ],
              [
                -7.726122,
                31.046388
              ],
              [
                -7.745137,
                31.091177
              ],
              [
                -7.673833,
                31.135944
              ],
              [
                -7.697601,
                31.150184
              ],
              [
                -7.708677,
                31.14497
              ]
            ]
          ]
        ]
      },
      "properties": {
        "cartodb_id": 8,
        "region": "Daraa-Tafilelt"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -8.668126,
                26.787388
              ],
              [
                -8.824203,
                26.787388
              ],
              [
                -8.976318,
                26.834057
              ],
              [
                -9.266287,
                27.265882
              ],
              [
                -9.356605,
                27.329245
              ],
              [
                -9.503967,
                27.308128
              ],
              [
                -9.698864,
                27.303905
              ],
              [
                -9.836718,
                27.434771
              ],
              [
                -9.955558,
                27.552839
              ],
              [
                -10.136195,
                27.510686
              ],
              [
                -10.274049,
                27.653939
              ],
              [
                -10.383382,
                27.712872
              ],
              [
                -10.635322,
                27.66657
              ],
              [
                -10.692365,
                27.729703
              ],
              [
                -11.177232,
                27.742326
              ],
              [
                -11.300825,
                27.6792
              ],
              [
                -11.471955,
                27.754946
              ],
              [
                -11.704881,
                27.771772
              ],
              [
                -11.766678,
                27.948282
              ],
              [
                -11.895025,
                28.10354
              ],
              [
                -11.904657,
                28.191148
              ],
              [
                -11.853035,
                28.2157
              ],
              [
                -11.460863,
                28.356976
              ],
              [
                -11.098401,
                28.743214
              ],
              [
                -10.836954,
                28.888987
              ],
              [
                -10.516086,
                29.065724
              ],
              [
                -10.450724,
                29.179921
              ],
              [
                -10.248696,
                29.304355
              ],
              [
                -10.052611,
                29.5476
              ],
              [
                -10.012403,
                29.617532
              ],
              [
                -9.993587,
                29.524594
              ],
              [
                -9.967442,
                29.516321
              ],
              [
                -9.910399,
                29.549409
              ],
              [
                -9.87237,
                29.445974
              ],
              [
                -9.824834,
                29.396287
              ],
              [
                -9.720255,
                29.439764
              ],
              [
                -9.67985,
                29.439764
              ],
              [
                -9.608546,
                29.398358
              ],
              [
                -9.563387,
                29.445974
              ],
              [
                -9.480199,
                29.423204
              ],
              [
                -9.444547,
                29.412852
              ],
              [
                -9.373243,
                29.454253
              ],
              [
                -9.304316,
                29.462531
              ],
              [
                -9.225881,
                29.441834
              ],
              [
                -9.161708,
                29.371435
              ],
              [
                -9.111795,
                29.230491
              ],
              [
                -9.064259,
                29.170323
              ],
              [
                -9.121302,
                29.078967
              ],
              [
                -9.121302,
                29.037414
              ],
              [
                -9.225881,
                28.989608
              ],
              [
                -9.175969,
                28.904334
              ],
              [
                -9.135563,
                28.866874
              ],
              [
                -9.104665,
                28.823154
              ],
              [
                -9.142693,
                28.704393
              ],
              [
                -9.028607,
                28.623058
              ],
              [
                -8.928782,
                28.531219
              ],
              [
                -8.871739,
                28.42258
              ],
              [
                -8.668126,
                28.238474
              ],
              [
                -8.668126,
                26.787388
              ]
            ]
          ]
        ]
      },
      "properties": {
        "cartodb_id": 10,
        "region": "Guelmim-Oued Noun"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -3.927604,
                32.612332
              ],
              [
                -4.03456,
                32.717378
              ],
              [
                -4.110617,
                32.629348
              ],
              [
                -4.186675,
                32.633351
              ],
              [
                -4.2865,
                32.701379
              ],
              [
                -4.348297,
                32.829292
              ],
              [
                -4.52418,
                32.953032
              ],
              [
                -4.614498,
                32.925105
              ],
              [
                -4.757106,
                32.949043
              ],
              [
                -4.76186,
                33.084565
              ],
              [
                -4.818903,
                33.156227
              ],
              [
                -4.913975,
                33.156227
              ],
              [
                -5.032815,
                33.116422
              ],
              [
                -5.085104,
                33.004871
              ],
              [
                -5.256234,
                32.980949
              ],
              [
                -5.313277,
                33.096512
              ],
              [
                -5.284755,
                33.211924
              ],
              [
                -5.408349,
                33.192036
              ],
              [
                -5.527189,
                33.283483
              ],
              [
                -5.617507,
                33.45419
              ],
              [
                -5.779129,
                33.477983
              ],
              [
                -5.807651,
                33.557246
              ],
              [
                -5.774376,
                33.723462
              ],
              [
                -5.722086,
                33.849887
              ],
              [
                -5.788636,
                33.909084
              ],
              [
                -5.72684,
                34.007655
              ],
              [
                -5.855187,
                34.102176
              ],
              [
                -5.897969,
                34.184795
              ],
              [
                -5.850433,
                34.231969
              ],
              [
                -5.802897,
                34.283045
              ],
              [
                -5.669796,
                34.231969
              ],
              [
                -5.679304,
                34.15333
              ],
              [
                -5.641275,
                34.141528
              ],
              [
                -5.503421,
                34.165131
              ],
              [
                -5.465392,
                34.251618
              ],
              [
                -5.503421,
                34.361563
              ],
              [
                -5.503421,
                34.424324
              ],
              [
                -5.398842,
                34.459607
              ],
              [
                -5.299016,
                34.510544
              ],
              [
                -5.213451,
                34.577108
              ],
              [
                -5.13264,
                34.819417
              ],
              [
                -4.985279,
                34.815515
              ],
              [
                -4.804642,
                34.874034
              ],
              [
                -4.719078,
                34.745237
              ],
              [
                -4.471891,
                34.710075
              ],
              [
                -4.281747,
                34.819417
              ],
              [
                -4.210443,
                34.772574
              ],
              [
                -4.039314,
                34.870134
              ],
              [
                -3.862242,
                34.914729
              ],
              [
                -3.705374,
                34.897186
              ],
              [
                -3.630504,
                34.882321
              ],
              [
                -3.61862,
                34.826246
              ],
              [
                -3.67804,
                34.728634
              ],
              [
                -3.770141,
                34.674899
              ],
              [
                -3.764199,
                34.589338
              ],
              [
                -3.835503,
                34.51593
              ],
              [
                -3.865213,
                34.447358
              ],
              [
                -3.939488,
                34.364016
              ],
              [
                -3.900865,
                34.2855
              ],
              [
                -3.838474,
                34.192167
              ],
              [
                -3.847387,
                33.978096
              ],
              [
                -3.939488,
                33.894289
              ],
              [
                -3.998908,
                33.793117
              ],
              [
                -4.085067,
                33.686882
              ],
              [
                -4.091009,
                33.622584
              ],
              [
                -4.013763,
                33.563188
              ],
              [
                -3.927604,
                33.612687
              ],
              [
                -3.8563,
                33.558237
              ],
              [
                -3.749344,
                33.649793
              ],
              [
                -3.793909,
                33.68441
              ],
              [
                -3.73746,
                33.770893
              ],
              [
                -3.624562,
                33.906618
              ],
              [
                -3.523549,
                33.965776
              ],
              [
                -3.4671,
                33.96824
              ],
              [
                -3.383912,
                33.904153
              ],
              [
                -3.22942,
                33.874557
              ],
              [
                -3.077899,
                33.854821
              ],
              [
                -3.048189,
                33.788179
              ],
              [
                -3.241304,
                33.64732
              ],
              [
                -3.250217,
                33.592891
              ],
              [
                -3.027392,
                33.469062
              ],
              [
                -2.923407,
                33.350019
              ],
              [
                -2.858045,
                33.278018
              ],
              [
                -2.965001,
                33.26063
              ],
              [
                -3.063044,
                33.220872
              ],
              [
                -3.181884,
                33.17861
              ],
              [
                -3.392825,
                33.158714
              ],
              [
                -3.547316,
                33.191042
              ],
              [
                -3.603765,
                33.168663
              ],
              [
                -3.752315,
                33.011847
              ],
              [
                -3.894923,
                32.832287
              ],
              [
                -3.972169,
                32.699879
              ],
              [
                -3.927604,
                32.612332
              ]
            ]
          ]
        ]
      },
      "properties": {
        "cartodb_id": 4,
        "region": "Fes-Meknes"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -3.109163,
                31.738455
              ],
              [
                -3.226449,
                31.805416
              ],
              [
                -3.187826,
                31.833186
              ],
              [
                -3.095725,
                31.853377
              ],
              [
                -3.14029,
                31.926531
              ],
              [
                -3.241304,
                32.029857
              ],
              [
                -3.220507,
                32.173312
              ],
              [
                -3.161087,
                32.241186
              ],
              [
                -3.327463,
                32.213539
              ],
              [
                -3.419564,
                32.20097
              ],
              [
                -3.499781,
                32.246211
              ],
              [
                -3.577026,
                32.193428
              ],
              [
                -3.651301,
                32.198456
              ],
              [
                -3.701808,
                32.258774
              ],
              [
                -3.776083,
                32.311519
              ],
              [
                -3.79688,
                32.409394
              ],
              [
                -3.906807,
                32.524699
              ],
              [
                -3.927604,
                32.612332
              ],
              [
                -3.972169,
                32.699879
              ],
              [
                -3.894923,
                32.832287
              ],
              [
                -3.752315,
                33.011847
              ],
              [
                -3.603765,
                33.168663
              ],
              [
                -3.547316,
                33.191042
              ],
              [
                -3.392825,
                33.158714
              ],
              [
                -3.181884,
                33.17861
              ],
              [
                -3.063044,
                33.220872
              ],
              [
                -2.965001,
                33.26063
              ],
              [
                -2.858045,
                33.278018
              ],
              [
                -2.923407,
                33.350019
              ],
              [
                -3.027392,
                33.469062
              ],
              [
                -3.250217,
                33.592891
              ],
              [
                -3.241304,
                33.64732
              ],
              [
                -3.048189,
                33.788179
              ],
              [
                -3.077899,
                33.854821
              ],
              [
                -3.22942,
                33.874557
              ],
              [
                -3.383912,
                33.904153
              ],
              [
                -3.4671,
                33.96824
              ],
              [
                -3.523549,
                33.965776
              ],
              [
                -3.624562,
                33.906618
              ],
              [
                -3.73746,
                33.770893
              ],
              [
                -3.793909,
                33.68441
              ],
              [
                -3.749344,
                33.649793
              ],
              [
                -3.8563,
                33.558237
              ],
              [
                -3.927604,
                33.612687
              ],
              [
                -4.013763,
                33.563188
              ],
              [
                -4.091009,
                33.622584
              ],
              [
                -4.085067,
                33.686882
              ],
              [
                -3.998908,
                33.793117
              ],
              [
                -3.939488,
                33.894289
              ],
              [
                -3.847387,
                33.978096
              ],
              [
                -3.838474,
                34.192167
              ],
              [
                -3.900865,
                34.2855
              ],
              [
                -3.939488,
                34.364016
              ],
              [
                -3.865213,
                34.447358
              ],
              [
                -3.835503,
                34.51593
              ],
              [
                -3.764199,
                34.589338
              ],
              [
                -3.770141,
                34.674899
              ],
              [
                -3.67804,
                34.728634
              ],
              [
                -3.61862,
                34.826246
              ],
              [
                -3.630504,
                34.882321
              ],
              [
                -3.705374,
                34.897186
              ],
              [
                -3.862242,
                34.914729
              ],
              [
                -3.840732,
                35.207527
              ],
              [
                -3.808051,
                35.239078
              ],
              [
                -3.763486,
                35.29002
              ],
              [
                -3.71595,
                35.297295
              ],
              [
                -3.671385,
                35.277894
              ],
              [
                -3.579284,
                35.234225
              ],
              [
                -3.522835,
                35.217236
              ],
              [
                -3.392112,
                35.202672
              ],
              [
                -3.314866,
                35.219663
              ],
              [
                -3.240591,
                35.236652
              ],
              [
                -3.172258,
                35.258488
              ],
              [
                -3.092041,
                35.302144
              ],
              [
                -3.020737,
                35.389386
              ],
              [
                -2.952404,
                35.442653
              ],
              [
                -2.928636,
                35.360316
              ],
              [
                -2.901897,
                35.29487
              ],
              [
                -2.895955,
                35.236652
              ],
              [
                -2.901897,
                35.161391
              ],
              [
                -2.85139,
                35.12495
              ],
              [
                -2.777115,
                35.115229
              ],
              [
                -2.720666,
                35.139528
              ],
              [
                -2.658275,
                35.112799
              ],
              [
                -2.557262,
                35.078767
              ],
              [
                -2.480016,
                35.120089
              ],
              [
                -2.417625,
                35.168677
              ],
              [
                -2.376031,
                35.141958
              ],
              [
                -2.292843,
                35.105507
              ],
              [
                -2.212626,
                35.120089
              ],
              [
                -2.244832,
                35.058341
              ],
              [
                -2.143818,
                34.999953
              ],
              [
                -2.042804,
                34.931781
              ],
              [
                -1.977442,
                34.951265
              ],
              [
                -1.9715,
                34.897674
              ],
              [
                -1.894254,
                34.839171
              ],
              [
                -1.858602,
                34.829417
              ],
              [
                -1.757588,
                34.741575
              ],
              [
                -1.85266,
                34.619417
              ],
              [
                -1.70411,
                34.467691
              ],
              [
                -1.781356,
                34.413786
              ],
              [
                -1.70411,
                34.305872
              ],
              [
                -1.727878,
                34.261685
              ],
              [
                -1.638748,
                34.089628
              ],
              [
                -1.692226,
                33.843224
              ],
              [
                -1.692226,
                33.774104
              ],
              [
                -1.715994,
                33.70987
              ],
              [
                -1.668458,
                33.670318
              ],
              [
                -1.603096,
                33.620852
              ],
              [
                -1.567444,
                33.5466
              ],
              [
                -1.597154,
                33.467327
              ],
              [
                -1.656574,
                33.353245
              ],
              [
                -1.626864,
                33.234044
              ],
              [
                -1.519908,
                33.109703
              ],
              [
                -1.454546,
                33.049957
              ],
              [
                -1.502082,
                32.975217
              ],
              [
                -1.549618,
                32.960261
              ],
              [
                -1.365417,
                32.735624
              ],
              [
                -1.234693,
                32.690628
              ],
              [
                -1.014839,
                32.515429
              ],
              [
                -1.098027,
                32.44024
              ],
              [
                -1.199041,
                32.420178
              ],
              [
                -1.240635,
                32.364987
              ],
              [
                -1.216867,
                32.309762
              ],
              [
                -1.240635,
                32.19921
              ],
              [
                -1.270345,
                32.174066
              ],
              [
                -1.181215,
                32.164007
              ],
              [
                -1.127737,
                32.118725
              ],
              [
                -1.288171,
                32.053278
              ],
              [
                -1.840776,
                32.053278
              ],
              [
                -2.197296,
                32.108659
              ],
              [
                -2.423091,
                32.098593
              ],
              [
                -2.631061,
                32.038169
              ],
              [
                -2.821205,
                32.053278
              ],
              [
                -2.898451,
                32.018018
              ],
              [
                -2.904393,
                31.886934
              ],
              [
                -2.916277,
                31.796074
              ],
              [
                -3.109163,
                31.738455
              ]
            ]
          ]
        ]
      },
      "properties": {
        "cartodb_id": 2,
        "region": "Oriental"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -6.83007,
                33.269573
              ],
              [
                -6.834823,
                33.010851
              ],
              [
                -6.958417,
                32.959015
              ],
              [
                -7.020213,
                32.715378
              ],
              [
                -6.934649,
                32.599317
              ],
              [
                -6.986938,
                32.422937
              ],
              [
                -7.029721,
                32.334617
              ],
              [
                -7.158068,
                32.346666
              ],
              [
                -7.2674,
                32.378788
              ],
              [
                -7.357719,
                32.487115
              ],
              [
                -7.486066,
                32.455032
              ],
              [
                -7.552616,
                32.455032
              ],
              [
                -7.619166,
                32.523196
              ],
              [
                -7.642934,
                32.611331
              ],
              [
                -7.771281,
                32.66337
              ],
              [
                -7.909136,
                32.80732
              ],
              [
                -7.966179,
                32.879208
              ],
              [
                -8.032729,
                32.80732
              ],
              [
                -8.042236,
                32.691378
              ],
              [
                -8.080265,
                32.659368
              ],
              [
                -8.027975,
                32.623342
              ],
              [
                -8.070758,
                32.539227
              ],
              [
                -8.260902,
                32.471075
              ],
              [
                -8.346466,
                32.346666
              ],
              [
                -8.503335,
                32.338634
              ],
              [
                -8.569885,
                32.447009
              ],
              [
                -8.579392,
                32.547241
              ],
              [
                -8.745768,
                32.539227
              ],
              [
                -8.84084,
                32.555255
              ],
              [
                -8.983448,
                32.631349
              ],
              [
                -8.997709,
                32.687377
              ],
              [
                -8.950173,
                32.719378
              ],
              [
                -8.988664,
                32.780696
              ],
              [
                -8.923632,
                32.825547
              ],
              [
                -8.761534,
                32.97073
              ],
              [
                -8.725882,
                33.018573
              ],
              [
                -8.6503,
                33.096263
              ],
              [
                -8.6175,
                33.151203
              ],
              [
                -8.628909,
                33.164335
              ],
              [
                -8.593257,
                33.198948
              ],
              [
                -8.564736,
                33.218039
              ],
              [
                -8.553327,
                33.220425
              ],
              [
                -8.557605,
                33.232354
              ],
              [
                -8.543344,
                33.249052
              ],
              [
                -8.519101,
                33.268132
              ],
              [
                -8.500562,
                33.26217
              ],
              [
                -8.490579,
                33.246667
              ],
              [
                -8.469188,
                33.251438
              ],
              [
                -8.434962,
                33.253823
              ],
              [
                -8.400737,
                33.278863
              ],
              [
                -8.366511,
                33.30032
              ],
              [
                -8.335137,
                33.326538
              ],
              [
                -8.308041,
                33.365851
              ],
              [
                -8.262407,
                33.371806
              ],
              [
                -8.193955,
                33.395622
              ],
              [
                -8.092704,
                33.430143
              ],
              [
                -7.96293,
                33.481304
              ],
              [
                -7.864531,
                33.511035
              ],
              [
                -7.824601,
                33.539567
              ],
              [
                -7.804636,
                33.531246
              ],
              [
                -7.729054,
                33.564525
              ],
              [
                -7.686271,
                33.595415
              ],
              [
                -7.644915,
                33.612044
              ],
              [
                -7.639211,
                33.604918
              ],
              [
                -7.623524,
                33.607293
              ],
              [
                -7.612115,
                33.607293
              ],
              [
                -7.59928,
                33.610856
              ],
              [
                -7.577889,
                33.612044
              ],
              [
                -7.565055,
                33.616794
              ],
              [
                -7.492325,
                33.653601
              ],
              [
                -7.41389,
                33.705817
              ],
              [
                -7.391073,
                33.718866
              ],
              [
                -7.392499,
                33.712935
              ],
              [
                -7.378238,
                33.708189
              ],
              [
                -7.34116,
                33.728354
              ],
              [
                -7.242761,
                33.790006
              ],
              [
                -7.191422,
                33.805412
              ],
              [
                -7.144361,
                33.822
              ],
              [
                -7.105857,
                33.846876
              ],
              [
                -7.078837,
                33.85837
              ],
              [
                -7.005953,
                33.812374
              ],
              [
                -7.005953,
                33.6305
              ],
              [
                -6.920388,
                33.666114
              ],
              [
                -6.811055,
                33.614667
              ],
              [
                -6.754012,
                33.606749
              ],
              [
                -6.744505,
                33.567149
              ],
              [
                -6.806302,
                33.531494
              ],
              [
                -6.763519,
                33.483931
              ],
              [
                -6.811055,
                33.345055
              ],
              [
                -6.83007,
                33.269573
              ]
            ]
          ]
        ]
      },
      "properties": {
        "cartodb_id": 6,
        "region": "Casablanca-Settat"
      }
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -8.668126,
                28.238474
              ],
              [
                -8.871739,
                28.42258
              ],
              [
                -8.928782,
                28.531219
              ],
              [
                -9.028607,
                28.623058
              ],
              [
                -9.142693,
                28.704393
              ],
              [
                -9.104665,
                28.823154
              ],
              [
                -9.135563,
                28.866874
              ],
              [
                -9.175969,
                28.904334
              ],
              [
                -9.225881,
                28.989608
              ],
              [
                -9.121302,
                29.037414
              ],
              [
                -9.121302,
                29.078967
              ],
              [
                -9.064259,
                29.170323
              ],
              [
                -9.111795,
                29.230491
              ],
              [
                -9.161708,
                29.371435
              ],
              [
                -9.225881,
                29.441834
              ],
              [
                -9.304316,
                29.462531
              ],
              [
                -9.373243,
                29.454253
              ],
              [
                -9.444547,
                29.412852
              ],
              [
                -9.480199,
                29.423204
              ],
              [
                -9.563387,
                29.445974
              ],
              [
                -9.608546,
                29.398358
              ],
              [
                -9.67985,
                29.439764
              ],
              [
                -9.720255,
                29.439764
              ],
              [
                -9.824834,
                29.396287
              ],
              [
                -9.87237,
                29.445974
              ],
              [
                -9.910399,
                29.549409
              ],
              [
                -9.967442,
                29.516321
              ],
              [
                -9.993587,
                29.524594
              ],
              [
                -10.012403,
                29.617532
              ],
              [
                -9.915945,
                29.785104
              ],
              [
                -9.779279,
                29.870158
              ],
              [
                -9.728772,
                30.004037
              ],
              [
                -9.654497,
                30.114608
              ],
              [
                -9.6337,
                30.258422
              ],
              [
                -9.601019,
                30.376398
              ],
              [
                -9.60399,
                30.417399
              ],
              [
                -9.648555,
                30.422523
              ],
              [
                -9.681236,
                30.51215
              ],
              [
                -9.713917,
                30.54286
              ],
              [
                -9.755511,
                30.565886
              ],
              [
                -9.794134,
                30.611922
              ],
              [
                -9.835728,
                30.619593
              ],
              [
                -9.880293,
                30.622149
              ],
              [
                -9.889206,
                30.665603
              ],
              [
                -9.859496,
                30.726916
              ],
              [
                -9.832757,
                30.775428
              ],
              [
                -9.808989,
                30.839222
              ],
              [
                -9.820873,
                30.849426
              ],
              [
                -9.814931,
                30.885128
              ],
              [
                -9.817902,
                30.920817
              ],
              [
                -9.826782,
                30.96461
              ],
              [
                -9.758284,
                30.918014
              ],
              [
                -9.772545,
                30.828253
              ],
              [
                -9.675096,
                30.82213
              ],
              [
                -9.537242,
                30.92617
              ],
              [
                -9.503967,
                30.856822
              ],
              [
                -9.430286,
                30.832335
              ],
              [
                -9.361359,
                30.92617
              ],
              [
                -9.306692,
                30.911896
              ],
              [
                -9.249649,
                30.824171
              ],
              [
                -9.154577,
                30.84866
              ],
              [
                -9.040491,
                30.834376
              ],
              [
                -8.969187,
                30.832335
              ],
              [
                -8.916898,
                30.932286
              ],
              [
                -8.850347,
                30.979166
              ],
              [
                -8.795681,
                30.993429
              ],
              [
                -8.743391,
                30.946556
              ],
              [
                -8.745768,
                30.852741
              ],
              [
                -8.71487,
                30.842539
              ],
              [
                -8.641189,
                30.891502
              ],
              [
                -8.484321,
                30.887423
              ],
              [
                -8.382118,
                30.881304
              ],
              [
                -8.306061,
                30.856822
              ],
              [
                -8.187221,
                30.924131
              ],
              [
                -8.123047,
                30.948595
              ],
              [
                -8.011338,
                30.897621
              ],
              [
                -7.940034,
                30.907818
              ],
              [
                -7.913889,
                30.968977
              ],
              [
                -7.882991,
                31.050461
              ],
              [
                -7.792673,
                31.105423
              ],
              [
                -7.697601,
                31.150184
              ],
              [
                -7.673833,
                31.135944
              ],
              [
                -7.745137,
                31.091177
              ],
              [
                -7.726122,
                31.046388
              ],
              [
                -7.716615,
                30.977128
              ],
              [
                -7.709485,
                30.862943
              ],
              [
                -7.659572,
                30.844579
              ],
              [
                -7.673833,
                30.775173
              ],
              [
                -7.676209,
                30.724107
              ],
              [
                -7.612036,
                30.717977
              ],
              [
                -7.550239,
                30.613712
              ],
              [
                -7.507457,
                30.529809
              ],
              [
                -7.588268,
                30.468371
              ],
              [
                -7.678586,
                30.437638
              ],
              [
                -7.671456,
                30.337174
              ],
              [
                -7.574007,
                30.310503
              ],
              [
                -7.595398,
                30.228392
              ],
              [
                -7.581138,
                30.187312
              ],
              [
                -7.500326,
                30.187312
              ],
              [
                -7.450414,
                30.146214
              ],
              [
                -7.393371,
                30.146214
              ],
              [
                -7.31256,
                30.111267
              ],
              [
                -7.281661,
                30.096873
              ],
              [
                -7.291168,
                30.172929
              ],
              [
                -7.155691,
                30.378192
              ],
              [
                -7.043981,
                30.310503
              ],
              [
                -7.001199,
                30.275614
              ],
              [
                -6.944156,
                30.31871
              ],
              [
                -6.858591,
                30.306399
              ],
              [
                -6.832446,
                30.394594
              ],
              [
                -6.751635,
                30.42944
              ],
              [
                -6.630419,
                30.47042
              ],
              [
                -6.606651,
                30.36999
              ],
              [
                -6.513956,
                30.367939
              ],
              [
                -6.452159,
                30.312554
              ],
              [
                -6.544854,
                30.19142
              ],
              [
                -6.485434,
                30.107155
              ],
              [
                -6.499695,
                30.002236
              ],
              [
                -6.437898,
                29.987827
              ],
              [
                -6.392739,
                30.033106
              ],
              [
                -6.335696,
                29.989885
              ],
              [
                -6.392739,
                29.893085
              ],
              [
                -6.442652,
                29.827125
              ],
              [
                -6.435521,
                29.769373
              ],
              [
                -6.506825,
                29.713653
              ],
              [
                -6.464588,
                29.681093
              ],
              [
                -6.487415,
                29.661259
              ],
              [
                -6.534951,
                29.588945
              ],
              [
                -6.606255,
                29.573443
              ],
              [
                -6.778572,
                29.583778
              ],
              [
                -6.962774,
                29.614777
              ],
              [
                -7.093498,
                29.676748
              ],
              [
                -7.12915,
                29.645767
              ],
              [
                -7.170744,
                29.630273
              ],
              [
                -7.194512,
                29.568275
              ],
              [
                -7.236106,
                29.537261
              ],
              [
                -7.343062,
                29.449337
              ],
              [
                -7.438134,
                29.407935
              ],
              [
                -7.509438,
                29.407935
              ],
              [
                -7.616393,
                29.397582
              ],
              [
                -7.693639,
                29.361337
              ],
              [
                -7.776827,
                29.288809
              ],
              [
                -7.860015,
                29.231787
              ],
              [
                -7.955087,
                29.179921
              ],
              [
                -7.996681,
                29.133219
              ],
              [
                -8.062043,
                29.081303
              ],
              [
                -8.222477,
                29.008577
              ],
              [
                -8.305665,
                28.982591
              ],
              [
                -8.347259,
                28.925399
              ],
              [
                -8.400737,
                28.956599
              ],
              [
                -8.394795,
                28.842154
              ],
              [
                -8.466098,
                28.831744
              ],
              [
                -8.59088,
                28.76926
              ],
              [
                -8.703778,
                28.701527
              ],
              [
                -8.668126,
                28.597236
              ],
              [
                -8.668126,
                28.238474
              ]
            ]
          ]
        ]
      },
      "properties": {
        "cartodb_id": 9,
        "region": "Souss Massa"
      }
    }
  ]
};

const MAJOR_CITIES = [
  "Casablanca",
  "Marrakech",
  "Fes",
  "Tanger",
  "Agadir",
  "Meknes",
  "Oujda",
  "Dakhla",
];

export default function Map({ Data = [] }) {
  const [hoveredCity, setHoveredCity] = useState(null);
  const [view, setView] = useState({ x: 0, y: 20, zoom: 0.9 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const { isDark } = useTheme();

  const project = ([lon, lat]) => {
    const x = (lon + 18) * 30; 
    const y = 500 - (lat - 20) * 30; 
    return [x, y];
  };

  const getPathData = (feature) => {
    const { type, coordinates } = feature.geometry;
    let path = "";

    if (type === "MultiPolygon") {
      coordinates.forEach(polygon => {
        polygon.forEach(ring => {
          path += " M " + ring.map(p => project(p).join(",")).join(" L ") + " Z ";
        });
      });
    } else if (type === "Polygon") {
      coordinates.forEach(ring => {
        path += " M " + ring.map(p => project(p).join(",")).join(" L ") + " Z ";
      });
    }
    return path;
  };

  const citiesOrders = useMemo(() => {
    return Data.map(item => ({
      ...item,
      svgCoords: item.coordinates ? project(item.coordinates) : [0, 0]
    })).filter(item => item.coordinates);
  }, [Data]);

  const maxOrders = Math.max(...citiesOrders.map(c => c.total_orders || 0), 1);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setDragStart({ x: e.clientX - view.x, y: e.clientY - view.y });
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    setView(prev => ({ ...prev, x: e.clientX - dragStart.x, y: e.clientY - dragStart.y }));
  };

  return (
    <div className="w-full bg-white rounded-xl overflow-hidden relative">
      {/* Zoom Controls */}
      <div className="absolute top-2 left-2 z-10 flex justify-center gap-1">
        <button onClick={() => setView(v => ({...v, zoom: v.zoom * 1.2}))} className="p-2 bg-white border rounded-full shadow-sm hover:bg-gray-50"><ZoomIn className="w-4 h-4 text-gray-600" /></button>
        <button onClick={() => setView(v => ({...v, zoom: v.zoom / 1.2}))} className="p-2 bg-white border rounded-full shadow-sm hover:bg-gray-50"><ZoomOut className="w-4 h-4 text-gray-600" /></button>
        <button onClick={() => setView({x:0, y:20, zoom:0.9})} className="p-2 bg-white border rounded-full shadow-sm hover:bg-gray-50"><RotateCcw className="w-4 h-4 text-gray-600" /></button>
      </div>

      <svg 
        viewBox="0 0 500 500" 
        className="w-full h-90 cursor-grab active:cursor-grabbing"
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={() => setIsDragging(false)}
        onMouseLeave={() => {
          setIsDragging(false);
          setHoveredCity(null);
        }}
      >
        <g transform={`translate(${view.x}, ${view.y}) scale(${view.zoom})`}>
          {/* Render Morocco Map */}
          {MOROCCO_GEOJSON.features.map((feature, i) => (
            <path
              key={i}
              d={getPathData(feature)}
              fill={isDark ? "#1c1917" : "#f9fafb"}
              stroke="#9ca3af"
              strokeWidth="0.5"
            />
          ))}

          {/* Render City Markers */}
          {citiesOrders.map((city, i) => {
            const [x, y] = city.svgCoords;
            const size = 4 + (12 * Math.sqrt(city.total_orders / maxOrders));
            const isHovered = hoveredCity?.city === city.city;

            return (
              <circle
                key={`marker-${i}`}
                cx={x} cy={y}
                r={size / view.zoom}
                fill={
                  isHovered
                    ? "var(--color-primary-600)"
                    : isDark
                      ? "var(--color-primary-500)" 
                      : "var(--color-primary-500)"
                }
                stroke={isDark ? "#292524" : "white"}
                strokeWidth={1 / view.zoom}
                opacity="0.8"
                style={{ cursor: 'pointer' }}
                onMouseEnter={() => setHoveredCity(city)}
                onMouseLeave={() => setHoveredCity(null)}
              />
            );
          })}
          {/* Render Major City Labels - Always Visible */}
          {citiesOrders
            .filter(city => MAJOR_CITIES.map(c => c.toLowerCase()).includes(city.city.toLowerCase()))
            .map((city, i) => {
              const [x, y] = city.svgCoords;
              const size = 4 + (12 * Math.sqrt(city.total_orders / maxOrders));
              
              return (
                <text
                  key={`major-label-${i}`}
                  x={x} 
                  y={y - (size + 2) / view.zoom}
                  textAnchor="middle"
                  fontSize={`${14 / view.zoom}px`}
                  fill="#000000"
                  stroke="#ffffff"
                  strokeWidth={`${3 / view.zoom}px`}
                  style={{ paintOrder: 'stroke', pointerEvents: 'none' }}
                >
                  {city.name}
                </text>
              );
            })}
        

          {/* Render Major City Labels - Always Visible */}
          {citiesOrders
            .filter(city => MAJOR_CITIES.includes(city.city))
            .map((city, i) => {
              const [x, y] = city.svgCoords;
              const size = 4 + (12 * Math.sqrt(city.total_orders / maxOrders));
              
              return (
                <text
                  key={`major-label-${i}`}
                  x={x} 
                  y={y - (size + 8) / view.zoom}
                  textAnchor="middle"
                  fontSize={`${14 / view.zoom}px`}
                  fontWeight="bold"
                  fill="#000000"
                  stroke="#000000"
                  strokeWidth={`${3 / view.zoom}px`}
                  style={{ paintOrder: 'stroke', pointerEvents: 'none' }}
                >
                  {city.city}
                </text>
              );
            })}

          {/* {hoveredCity && (
            <g pointerEvents="none">
              <rect
                x={hoveredCity.svgCoords[0] + 12 / view.zoom}
                y={hoveredCity.svgCoords[1] - 25 / view.zoom}
                width={140 / view.zoom}
                height={35 / view.zoom}
                rx={5 / view.zoom}
                
                fill="white"
                stroke="#d1d5db"
                strokeWidth={0.5 / view.zoom}
              />
              <text
                x={hoveredCity.svgCoords[0] + 18 / view.zoom}
                y={hoveredCity.svgCoords[1] - 12 / view.zoom}
                fontSize={`${15 / view.zoom}px`}
                fontWeight="500"
                fill="#111827"
                height={15}
              >
                {hoveredCity.city}
              </text>
              <text
                x={hoveredCity.svgCoords[0] + 18 / view.zoom}
                y={hoveredCity.svgCoords[1] + 2 / view.zoom}
                fontSize={`${12 / view.zoom}px`}
                fill="#6b7280"
              >
                Orders: {hoveredCity.total_orders || 0}
              </text>
            </g>
          )} */}
          {hoveredCity && (
            <g pointerEvents="none">
              
              {/* Main tooltip background */}
              <rect
                x={hoveredCity.svgCoords[0] + 12 / view.zoom}
                y={hoveredCity.svgCoords[1] - 32 / view.zoom}
                width={160 / view.zoom}
                height={50 / view.zoom}
                rx={6 / view.zoom}
                fill="white"
                stroke="#e5e7eb"
                strokeWidth={1 / view.zoom}
              />
              
              {/* Accent bar on left */}
              <rect
                x={hoveredCity.svgCoords[0] + 12 / view.zoom}
                y={hoveredCity.svgCoords[1] - 32 / view.zoom}
                width={4 / view.zoom}
                height={50 / view.zoom}
                rx={6 / view.zoom}
                fill="var(--color-primary-500)"
              />
              
              {/* City name */}
              <text
                x={hoveredCity.svgCoords[0] + 26 / view.zoom}
                y={hoveredCity.svgCoords[1] - 11 / view.zoom}
                fontSize={`${14 / view.zoom}px`}
                fontWeight="600"
                fill="#111827"
                letterSpacing="0.5"
              >
                {hoveredCity.name}
              </text>
              
              {/* Orders label */}
              <text
                x={hoveredCity.svgCoords[0] + 26 / view.zoom}
                y={hoveredCity.svgCoords[1] + 5 / view.zoom}
                fontSize={`${13 / view.zoom}px`}
                fontWeight="400"
                fill="#9ca3af"
              >
                Orders:
              </text>
              
              {/* Orders count */}
              <text
                x={hoveredCity.svgCoords[0] + 70 / view.zoom}
                y={hoveredCity.svgCoords[1] + 5 / view.zoom}
                fontSize={`${14 / view.zoom}px`}
                fontWeight="500"
                fill="var(--color-primary-600)"
              >
                {hoveredCity.total_orders || 0}
              </text>
            </g>
          )}
        </g>
      </svg>
    </div>
  );
}